window.addEventListener("DOMContentLoaded", paymentTypeToggle);

function paymentTypeToggle() {
    var toggleBtns = Array.from(document.querySelectorAll(".payment-type-toggle__option"));
    var paymentTypeChangeEvent = new Event("paymentTypeChange");
    var allPaymentOptions = Array.from(document.querySelectorAll("[data-payment-type]"));

    toggleBtns.forEach(clickedBtn => {
        clickedBtn.addEventListener("click", function () {
            if (clickedBtn.classList.contains("active")) return;

            var selectedType = clickedBtn.getAttribute("data-target-payment-type");

            toggleBtns.forEach(btn => {
                var paymentType = btn.getAttribute("data-target-payment-type");
                if (paymentType === selectedType) {
                    btn.classList.add("active");
                } else {
                    btn.classList.remove("active");
                }
            });

            allPaymentOptions.forEach(po => {
                var paymentType = po.getAttribute("data-payment-type");
                if (paymentType === selectedType) {
                    po.classList.add("active");
                } else {
                    po.classList.remove("active");
                }
            });

            window.dispatchEvent(paymentTypeChangeEvent);
        });
    })
}